import { render, staticRenderFns } from "./configDialog.vue?vue&type=template&id=daa24526&scoped=true"
import script from "./configDialog.vue?vue&type=script&lang=js"
export * from "./configDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa24526",
  null
  
)

export default component.exports